export const CONVERSATION = {
  SMS: "SMS",
  INBOUND_VOICE: "INBOUNDVOICE",
  OUTBOUND_VOICE: "OUTBOUNDVOICE",
  EMBEDDED_CHAT: "EMBEDDEDCHAT",
  WHATSAPP: "WHATSAPP",
  WEB_CALL: "WEBCALL",
  API: "API",
  MESSENGER: "MESSENGER",
  INSTAGRAM: "INSTAGRAM",
  MCUBE_ENGAGE_WHATSAPP: "MCUBE_ENGAGE_WHATSAPP"
};
